/* @flow */
import Checkbox from 'components/Checkbox.jsx';
import CurrentUser from 'auth/CurrentUser';
import * as React from 'react';
import ToastActions from 'actions/ToastActions';

const INCLUDE_IN_OWN_BROADCASTS_PREF = 'include_in_own_broadcasts';

class IncludeInOwnBroadcastsPreference extends React.Component<{}, $FlowFixMeState> {
  state = {
    includeInOwnBroadcasts: CurrentUser.getUser().getPreference(INCLUDE_IN_OWN_BROADCASTS_PREF),
  };

  handleChange = (e: SyntheticInputEvent<>) => {
    const includeInOwnBroadcasts = e.target.checked;

    const onSuccess = () => {
      this.setState({ includeInOwnBroadcasts });
      const message = includeInOwnBroadcasts
        ? 'You will receive copies of your class announcements'
        : 'You will no longer receive copies of your class announcements';
      ToastActions.showSuccessToast(message);
    };

    const onError = () => {
      ToastActions.showErrorToast('Failed to save preference');
    };

    CurrentUser.getUser()
      .savePreference(INCLUDE_IN_OWN_BROADCASTS_PREF, includeInOwnBroadcasts)
      .then(onSuccess, onError);
  };

  render() {
    return (
      <div className="NotificationSettingsView-device">
        <Checkbox
          label="Receive copies of your class announcements"
          onChange={this.handleChange}
          defaultChecked={this.state.includeInOwnBroadcasts}
        />
      </div>
    );
  }
}

export default IncludeInOwnBroadcastsPreference;
